import {Subscription} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, OnDestroy, OnInit, resource} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngxs/store';
import {DashboardStudyViewRegionsComponent} from '../dashboard-study-view-regions/dashboard-study-view-regions.component';
import {DashboardStudyViewerComponent} from '../dashboard-study-viewer/dashboard-study-viewer.component';
import {DashboardStudyDataZoneComponent} from '../dashboard-study-data-zone/dashboard-study-data-zone.component';
import {DashboardStudy} from '../../../dashboard-new/types/dashboard.types';
import {LoadDashboardStudyDetails, ResetDashboardStudyDetails} from '../../../dashboard-new/states/dashboard/dashboard.actions';
import {DashboardState} from '../../../dashboard-new/states/dashboard/dashboard.state';
import {PROGRESS_STATUSES} from '../../../shared/symbols';
import {RtDynamicScriptsService} from '../../../rt-dynamic-scripts/rt-dynamic-scripts.service';

@Component({
  selector: 'app-dashboard-study',
  templateUrl: './dashboard-study.component.html',
  styleUrls: ['./dashboard-study.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, DashboardStudyViewRegionsComponent, DashboardStudyViewerComponent, DashboardStudyDataZoneComponent],
})
export class DashboardStudyComponent implements OnInit, OnDestroy {
  public readonly dashboardUser$ = this.store.select(DashboardState.dashboardUser);
  public readonly loadDashboardStudyDetailsProgress$ = this.store.select(DashboardState.loadDashboardStudyDetailsProgress);
  public readonly dashboardStudyDetails$ = this.store.select(DashboardState.dashboardStudyDetails);
  public readonly lastLoadDashboardStudyDetailsError$ = this.store.select(DashboardState.lastLoadDashboardStudyDetailsError);

  /** Resource that loads the Papaya script dynamically. */
  public readonly papayaScript = resource({
    loader: () => this.scriptsLoadingService.load('papaya').then(() => true),
  });

  /** Available progress statuses saved in local variable. */
  public readonly progressStatuses = PROGRESS_STATUSES;

  // Todo: move to state?
  public isSwipeBlockOpened = false;

  /** Contain component subscriptions. Will be unsubscribed on destroy. */
  private readonly subscription = new Subscription();

  constructor(private store: Store, private scriptsLoadingService: RtDynamicScriptsService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Load the dashboard data for the selected study.
    this.subscription.add(
      this.route.params
        .pipe(
          // Extract the studyUid from the route parameters.
          map(params => params?.studyUid),

          // Filter out any falsy values (e.g., if studyUid is undefined).
          filter(studyUid => !!studyUid)
        )
        .subscribe((studyUid: DashboardStudy['id']) => {
          this.store.dispatch(new LoadDashboardStudyDetails(studyUid));
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();

    // Reset the dashboard study data and statuses when the component is destroyed.
    // Used to avoid displaying the previous study data when navigating to a different study.
    this.store.dispatch(new ResetDashboardStudyDetails());
  }

  /**
   * Update the local variable that represents the state of the swipe block.
   * Todo: check if needed
   */
  public swipeBlockStateChanged(isExpanded: boolean): void {
    this.isSwipeBlockOpened = isExpanded;
  }
}
